// extracted by mini-css-extract-plugin
export default {"taple_container":"taple_taple_container__Yh+xX","pagination":"taple_pagination__6aO2X","print":"taple_print__9C8qL","openModal":"taple_openModal__e5pNk"};